<template lang="pug">
  v-container.px-1.shops-detail-container(fluid)
    //- update virtual store
    v-dialog(v-if='shop' persistent :key='shop.id' :value='updateItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      update-shop(:model ='shop' @close="updateItemDialog=false;")
    v-card.rounded-lg.px-5.pb-5.card-shop-detail(height="600px")
      v-row
        //- Update store
        v-speed-dial(style="right: 0" direction='left' absolute)
          v-btn(slot='activator' color='success' light fab text)
            v-icon(size="40") mdi-dots-horizontal
          v-btn(fab small color='green' @click.stop ='updateStore')
            v-icon mdi-pen
        v-card
            v-card-title.text-centered Movimientos del mes
            v-card-text
              v-row
                v-col(cols="6" lg ="4" xl="4" v-for="(stat, index) in statsList" :key="index")
                  v-list-item
                    v-list-item-content
                      v-list-item-title {{ stat.title }}:
                      v-list-item-subtitle.font-weight-bold {{ formatValue(stat.value, stat.isCurrency) }}
      v-row.my-2.switchsection(cols="12" xs="12" sm="7" md="7")
          v-tooltip(bottom)
            template(v-slot:activator="{ on, attrs }")
              v-card.main-btn-gradient.px-2.mx-auto(flat outlined height="60" width="200" v-bind="attrs" v-on="on" :href="storeLink" target="_blank")
                .d-flex.flex-row.justify-center.align-center(style="height: 100%;")
                  v-img.mr-1(src="@/assets/icons/home/creartienda.png" height="80%" width="20%" contain)
                  span.h2.text-uppercase.text-center {{$t('shops.details.go_to_pos')}}
            span El pos es tu punto de venta, donde puedes facturar y hacer ventas
          v-switch(v-model="switchMe" @change="changeStateCashRegister" :loading="loadingState")
              template(v-slot:label="")
                | {{$t('shops.details.state_cash_register')}}
                | {{switchMe ? $t('shops.details.open') : $t('shops.details.closed')}}
                v-tooltip(top="")
                    template(v-slot:activator="{ on }")
                      v-btn(fab icon color="primary" dark="" v-on="on")
                          v-icon mdi-alert-circle-outline
                    span {{$t('shops.details.close_message')}}

      v-row.d-flex.justify-center(cols="12" xs="12" sm="5" md="5")
        v-img(v-if="shop.pictures" height="180" :src='getImage(shop.pictures.imageInput1)' contain)
          template(v-slot:placeholder)
            v-row.fill-height.ma-0(align="center" justify="center")
              v-progress-circular(indeterminate color="grey lighten-5")
      .card-content-overflow
        v-row
            v-col(cols="12" xs="12" sm="6" md="6")
                v-text-field(disabled v-bind:label="$t('shops.details.store_name')"  type="text", v-model='shop.name')
                v-text-field(disabled v-bind:label="$t('shops.details.nit')"  type="text", v-model='shop.ref_id')
                v-text-field(v-if="shop.mainCategorieSelect" disabled v-bind:label="$t('shops.details.mainCategory')"  type="text", v-model='shop.mainCategorieSelect.data')
            v-col(cols="12" xs="12" sm="6" md="6")
                v-text-field(disabled v-bind:label="$t('shops.details.phone')"  type="text", v-model='shop.phone')
                v-text-field(disabled v-bind:label="$t('shops.details.address')"  type="text", v-model='shop.address')

        h3 {{$t('shops.details.categories')}}
        v-select(v-if ='!!shop.categories' disabled v-model='shop.categories', :items='shop.categories' item-text='name' , multiple='', chips='')
</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  export default {
    components: {
      UpdateShop: () => import('@/views/custom/UpdateShop.vue'),
    },
    mixins: [loaders],
    data () {
      return {
        updateItemDialog: false,
        switchMe: false,
        baseLink: 'https://pos-tender.web.app/pos',
        loadingState: false,
        content: {},
      }
    },
    computed: {
      statsList () {
        return [
          { title: 'Ventas', value: this.totalMonthlyStats.dailyInvoices, isCurrency: false },
          { title: 'Valor Ventas', value: this.totalMonthlyStats.storeValue, isCurrency: true },
          { title: 'Compras', value: this.totalMonthlyStats.dailyPurchases, isCurrency: false },
          { title: 'Valor Compras', value: this.totalMonthlyStats.storePurchaseValue, isCurrency: true },
          { title: 'Ordenes', value: this.totalMonthlyStats.orders, isCurrency: false },
          { title: 'Utilidad total', value: this.totalMonthlyStats.dailyProfit, isCurrency: true },

        ]
      },
      shop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      storeLink () {
        const vm = this
        return `${vm.baseLink}/${vm.userId}/${vm.shop.id}`
      },
      userId () {
        return this.$store.state.users.user.adminUid ? this.$store.state.users.user.adminUid : this.$store.state.users.user.uid
      },
      currentStats () {
        return this.$store.getters['shops/getCurrentStats']
      },
      totalMonthlyStats () {
        return this.$store.getters['shops/getTotalMonthlyStats']
      },
    },
    created () {
      const vm = this
      if (vm.shop.status.val === 'active') {
        vm.switchMe = true
      } else {
        vm.switchMe = false
      }
      this.loadStats()
    },

    methods: {
      changeStateCashRegister () {
        const vm = this
        vm.loadingState = true
        const data = {
          userId: vm.$store.state.users.user.uid,
          shopId: vm.shop.id,
          action: vm.switchMe ? 'open' : 'close',
        }
        vm.$store.dispatch('pos/stateCashRegister', data).then(() => {
          vm.loadingState = false
        }).catch((error) => {
          console.log(error)
          vm.loadingState = false
        })
      },
      updateStore () {
        const vm = this
        vm.content = { ...vm.shop }
        vm.updateItemDialog = true
      },
      loadStats () {
        this.$store.dispatch('shop/loadMonthlyStats')
      },
      formatValue (value, isCurrency) {
        if (isCurrency) {
          return '$ ' + new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'COP' }).format(value)
        }
        return value
      },
    },
  }
</script>

<style lang="scss" scoped>
  .shops-detail-container{
    //- height: 91%;
    .card-shop-detail{
      overflow-y: scroll !important;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .card-right{
      @media (min-width: 600px){
        position: absolute;
        right: 5px;
      }
    }
  }
  .switchsection{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .text-centered{
    text-align: center;
    justify-content: center;
  }
</style>
